import 'react-datepicker/dist/react-datepicker.css'
import './RawDatePicker.css'

import React from 'react'
import DatePicker, { ReactDatePickerProps } from 'react-datepicker'

import { RawInput } from '../input'
import { classes } from '../utils'

type Props = {
  /** HTML for attribute */
  htmlFor: string
  /** True if the box is in invalid state. */
  isInvalid?: boolean
  /** Optional className for custom styling */
  className?: string
}

/** Date Picker component. This is a wrapper around react-datepicker such that we can style
 * the data picker using the Ditto tailwindUI based theme.
 */
const RawDatePicker = <
  CustomModifierNames extends string = never,
  WithRange extends boolean | undefined = undefined,
>({
  htmlFor,
  isInvalid,
  className,
  ...other
}: ReactDatePickerProps<CustomModifierNames, WithRange> & Props) => {
  return (
    <DatePicker
      customInput={<RawInput id={htmlFor} isInvalid={isInvalid} />}
      calendarClassName={classes('dittoCalendar', className)}
      showTimeInput={false}
      {...other}
    />
  )
}

export default RawDatePicker
